import * as React from "react";
import { SVGProps } from "react";
const SvgRewardProgram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 0C10.477 0 6 4.477 6 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 16 0Zm8 18.926v11.27a1 1 0 0 1-1.53.848l-5.94-3.713a1 1 0 0 0-1.06 0l-5.94 3.713A1 1 0 0 1 8 30.196v-11.27a11.948 11.948 0 0 0 16 0ZM16 2l1.796 5.528h5.812l-4.702 3.416 1.796 5.528L16 13.056l-4.702 3.416 1.796-5.528-4.702-3.416h5.812L16 2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRewardProgram;
